import React, { useEffect, useState } from "react";
import EMPModal from "../Components/modals/EMPModal";
import Swal from "sweetalert2";
import image1 from "../assets/images/executive.914c1c1e735aaecabb8f.png";
import axios from "axios";
import { useAuth } from "../../src/Context/AuthContext";

const EmployeeSelection = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [employee, setEmployee] = useState(null);
  const [period, setPeriod] = useState(localStorage.getItem("period") || "");
  const [year, setYear] = useState(localStorage.getItem("year") || "");
  const [employeeImage, setEmployeeImage] = useState(null);
  const [imageError, setImageError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const [statuses, setStatuses] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState("");
  const { request_token } = useAuth();
  const serviceNo = employee?.id || localStorage.getItem("username");
  const userType = "Ex";
  const reportOfficerStatus =
    localStorage.getItem("ReportOfficer_Status") === "true";

  useEffect(() => {
    const storedEmployee = localStorage.getItem("employeeData");
    if (storedEmployee) {
      setEmployee(JSON.parse(storedEmployee));
    }
  }, []);

  const handleEmployeeSelect = (employeeData) => {
    const transformedData = {
      id: employeeData.ServiceNo,
      estatus: employeeData?.EvaluationStatus || "No Status",
      name: employeeData.ReportName,
      designation: employeeData.Category,
      division: employeeData.DivisionName,
      department: employeeData.DepartmentName,
      recruitmentDate: employeeData.RecruitmentDate,
      basicSalary: employeeData.BasicSalary,
      permanentDate: employeeData.PermanentDate,
      presentGrade: employeeData.PresentGrade,
      retirementDate: employeeData.RetirementDate,
      workCategory: employeeData.WorkCategory,
      basisOfEmployment: employeeData.BasicSalary,
    };


    setEmployee(transformedData);
    localStorage.setItem("employeeData", JSON.stringify(transformedData));


    localStorage.setItem("serviceNo", employeeData.ServiceNo);
  };

  const toggleModal = () => {
    const missingValues = [];

    if (!localStorage.getItem("year")) missingValues.push("Year");
    if (!localStorage.getItem("period")) missingValues.push("Period");

    if (missingValues.length > 0) {
      Swal.fire({
        title: "Warning!",
        text: `Please select "${missingValues.join(
          " And "
        )}" before proceeding.`,
        icon: "warning",
      });
    } else {
      setIsModalOpen(!isModalOpen);
    }
  };
  const handlePeriodChange = (e) => {
    const value = e.target.value;
    setPeriod(value);
    localStorage.setItem("period", value);
    window.location.reload();
  };

  const handleYearChange = (e) => {
    const value = e.target.value;
    setYear(value);
    localStorage.setItem("year", value);
    window.location.reload();
  };

  useEffect(() => {
    if (period && year) {
      loadStatuses();
    }
  }, [period, year]);

  const loadStatuses = async () => {
    setIsLoading(true);
    setError("");

    try {
      const response = await axios.get("Evaluation/GetStatus", {
        params: {
          serviceNo,
          UserType: userType,
          period,
          year,
        },
        headers: {
          request_token,
        },
      });

      if (response.status === 200 && response.data.ResultSet) {
        const statuses = response.data.ResultSet;
        setStatuses(statuses);

        const inCompleteStatus = statuses.find(
          (status) => status.Value.toLowerCase() === "in complete"
        );
        setSelectedStatus(
          inCompleteStatus ? inCompleteStatus.Key : statuses[0]?.Key || ""
        );
      } else {
        setError("Failed to load statuses.");
      }
    } catch (error) {
      setError("An error occurred while loading statuses.");
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleReset = () => {

    const storedServiceNo = localStorage.getItem("username");


    setEmployee(null);
    setPeriod("");
    setYear("");
    setSelectedStatus("");
    setEmployeeImage(null);
    setImageError(false);



    localStorage.removeItem("serviceNo");
    localStorage.removeItem("period");
    localStorage.removeItem("year");
    localStorage.removeItem("selectedDivision");
    localStorage.removeItem("selectedLocation");
    localStorage.removeItem("employeeData");
    localStorage.removeItem("DepartmentCode");
    localStorage.removeItem("DivisionCode");
    localStorage.removeItem("lastEmployeeImage");


    if (storedServiceNo) {
      localStorage.setItem("serviceNo", storedServiceNo);
    }


    Swal.fire({
      icon: "success",
      title: "Data Reset",
      text: "All data has been cleared successfully.",
      confirmButtonColor: "#3085d6",
    }).then(() => {

      setEmployeeImage(image1);
      setEmployee(null);
    });
  };

  useEffect(() => {
    const fetchImage = async () => {
      if (!employee?.id && !serviceNo) return;

      try {
        const apiUrl = `https://esystems.cdl.lk/backend/PerformanceEvaluationNew/Evaluation/GetUserImg?serviceNo=${reportOfficerStatus ? employee?.id : serviceNo
          }`;

        console.log("Fetching image from:", apiUrl);

        const response = await fetch(apiUrl);

        if (response.ok) {
          const blob = await response.blob();
          const imageUrl = URL.createObjectURL(blob);
          setEmployeeImage(imageUrl);
          localStorage.setItem("lastEmployeeImage", imageUrl);
          setImageError(false);
        } else {
          setImageError(true);
        }
      } catch (error) {
        console.error("Error fetching image:", error);
        setImageError(true);
      }
    };

    if (reportOfficerStatus ? employee?.id : serviceNo) {
      fetchImage();
    } else {

      const storedImage = localStorage.getItem("lastEmployeeImage");
      if (storedImage) {
        setEmployeeImage(storedImage);
      } else {
        setEmployeeImage(null);
      }
    }
  }, [employee?.id, reportOfficerStatus, serviceNo]);


  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const response = await axios.get("Evaluation/GetPersonalData", {
          params: {
            serviceNo: localStorage.getItem("username"),
            UserType: "EX",
          },
          headers: { request_token },
        });

        if (response.data.StatusCode === 200) {
          const userData = response.data.ResultSet;

          setEmployee(
            (prev) =>
              prev || {
                id: userData.ServiceNo,
                name: userData.ReportName,
                designation: userData.Category,
                division: userData.DivisionName,
                department: userData.DepartmentName,
                recruitmentDate: userData.RecruitmentDate,
                basicSalary: userData.BasicSalary,
                permanentDate: userData.PermanentDate,
                presentGrade: userData.PresentGrade,
                retirementDate: userData.RetirementDate,
                workCategory: userData.WorkCategory,
                basisOfEmployment: userData.BasicSalary,
              }
          );
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    if (!localStorage.getItem("employeeData")) {
      fetchUserData();
    }
  }, [request_token]);

  return (
    <div className="bg-gray-50 shadow-md p-6 rounded-lg space-y-6">
      {/* Header Section */}
      <div className="flex flex-col md:flex-row justify-between items-center border-b pb-4">
        <div>
          <h2 className="text-2xl font-bold text-blue-800 ">
            Employee Evaluation
          </h2>
          <p className="text-sm text-gray-400">
            Manage and evaluate employee performance effectively.
          </p>
        </div>

        <div className="flex gap-2 md:gap-4 mt-4 md:mt-0">
          <button
            onClick={toggleModal}
            className={`px-4 py-2 rounded-md shadow transition ${reportOfficerStatus
                ? "bg-blue-600 text-white hover:bg-blue-700"
                : "bg-gray-400 text-gray-700 cursor-not-allowed"
              }`}
            disabled={!reportOfficerStatus}
          >
            Select Employee
          </button>
          <button
            onClick={handleReset}
            className="bg-red-500 text-white px-4 py-2 rounded-md shadow hover:bg-red-600 transition"
          >
            Reset
          </button>
        </div>
      </div>
      {/* Content Section */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        {/* Left Section */}
        <div className="col-span-2 space-y-4">
          <div className="bg-white p-4 rounded-lg shadow">
            <h3 className="text-lg font-bold text-gray-700 mb-2">
              Employee Details
            </h3>
            <p className="text-gray-600 text-sm">
              {employee ? (
                <span>
                  <strong className="text-green-600">ID: </strong>
                  <span className="font-bold text-blue-600 mr-2">
                    {employee?.id || localStorage.getItem("username")}{" "}
                    {/* Combined check */}
                  </span>
                  | <strong className="text-green-600">Name: </strong>
                  <span className="font-bold text-blue-600 mr-2">
                    {employee.name || "N/A"}
                  </span>
                  <div>
                    <strong className="text-green-600">Work Category: </strong>
                    <span className="font-bold text-blue-600">
                      {employee.workCategory || "N/A"}
                    </span>
                  </div>
                </span>
              ) : (
                <span>
                  <strong className="text-green-600">ID: </strong>
                  <span className="font-bold text-blue-600 mr-2">
                    {serviceNo || "N/A"}{" "}
                    {/* Display logged-in user's username */}
                  </span>
                  | <strong className="text-green-600">Name: </strong>
                  <span className="font-bold text-blue-600 mr-2">{"N/A"}</span>
                </span>
              )}
            </p>
          </div>

          <div className="bg-white p-4 rounded-lg shadow grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-600 mb-1">
                Evaluation Status
              </label>
              <select
                className="w-full p-2 border rounded shadow-sm"
                onFocus={loadStatuses}
                onChange={(e) => setSelectedStatus(e.target.value)}
                value={selectedStatus || "incomplete"}
              >
                {statuses.length === 0 ? (
                  <option value="incomplete">In Complete</option>
                ) : (
                  statuses.map((status, index) => (
                    <option key={index} value={status.Key}>
                      {status.Value}
                    </option>
                  ))
                )}
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-600 mb-1">
                Category
              </label>
              <select className="w-full border border-gray-300 px-3 py-2 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500">
                <option>Executive</option>
                <option>Non-Executive</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-600 mb-1">
                Period
              </label>
              <select
                className="w-full border border-gray-300 px-3 py-2 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                value={period}
                onChange={handlePeriodChange}
              >
                <option value="">Select the Period</option>
                <option value="1">Mid year</option>
                <option value="2">Year end</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium text-gray-600 mb-1">
                Year
              </label>
              <select
                className="w-full border border-gray-300 px-3 py-2 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                value={year}
                onChange={handleYearChange}
              >
                <option value="">Select the Year</option>
                <option value="2021">2021</option>
                <option value="2022">2022</option>
                <option value="2023">2023</option>
                <option value="2024">2024</option>
                <option value="2025">2025</option>
                <option value="2026">2026</option>
              </select>
            </div>
          </div>
        </div>
        {/* Right Section */}
        <div className="space-y-2 mt-6">
          {" "}
          {/* Add margin-top to move it lower */}
          <div className="bg-white p-4 rounded-lg shadow flex flex-col items-center">

            {employeeImage && !imageError ? (
              <img
                src={employeeImage}
                alt="Employee"
                className="w-55 h-40 object-cover border border-gray-300 shadow mb-5"
              />
            ) : (
              <img
                src={image1}
                alt="Default Placeholder"
                className="w-32 h-32 object-cover border border-gray-300 shadow mb-4"
              />
            )}
            <p className="text-gray-600 font-bold text-sm">
              {employee?.name || "No Employee Selected"}
            </p>
          </div>
        </div>
      </div>
      {/* Employee Details Section */}
      <div className="bg-white shadow-xl p-3 rounded-x1 mt-6 max-w-5x1 mx-auto">
        <h2 className="text-2xl font-bold text-blue-800 mb-3 border-b pb-2 center">
          Employee Overview
        </h2>
        {employee ? (
          <div className="grid grid-cols-2 md:grid-cols-1 gap-2">
            {/* Display employee details in a grid layout */}
            <div className="bg-gray-100 p-1 rounded-lg shadow-md">
              <p className="text-lg font-bold text-green-700">Name :</p>
              <p className="text-l font-semibold text-blue-800">
                {employee.name ? employee.name : "-"}
              </p>
            </div>
            <div className="bg-gray-100 p-1 rounded-lg shadow-md">
              <p className="text-lg font-bold text-green-700">Designation :</p>
              <p className="text-l font-semibold text-blue-800">
                {employee.designation ? employee.designation : "-"}
              </p>
            </div>
            <div className="bg-gray-100 p-1 rounded-lg shadow-md">
              <p className="text-lg font-bold text-green-700">Division :</p>
              <p className="text-l font-semibold text-blue-800">
                {employee.division ? employee.division : "-"}
              </p>
            </div>
            <div className="bg-gray-100 p-1 rounded-lg shadow-md">
              <p className="text-lg font-bold text-green-700">Department :</p>
              <p className="text-l font-semibold text-blue-800">
                {employee.department ? employee.department : "-"}
              </p>
            </div>
            <div className="bg-gray-100 p-1 rounded-lg shadow-md">
              <p className="text-lg font-bold text-green-700">
                Recruitment Date :
              </p>
              <p className="text-l font-semibold text-blue-800">
                {employee.recruitmentDate ? employee.recruitmentDate : "-"}
              </p>
            </div>
            
            {/* <div className="bg-gray-100 p-1 rounded-lg shadow-md">
              <p className="text-lg font-bold text-green-700">Basic Salary :</p>
              <p className="text-l font-semibold text-blue-800">
                {employee.basicSalary ? employee.basicSalary : "-"}
              </p>
            </div> */}

            <div className="bg-gray-100 p-1 rounded-lg shadow-md">
              <p className="text-lg font-bold text-green-700">
                Permanent Date :
              </p>
              <p className="text-l font-semibold text-blue-800">
                {employee.permanentDate ? employee.permanentDate : "-"}
              </p>
            </div>
            <div className="bg-gray-100 p-1 rounded-lg shadow-md">
              <p className="text-lg font-bold text-green-700">
                Present Grade :
              </p>
              <p className="text-l font-semibold text-blue-800">
                {employee.presentGrade ? employee.presentGrade : "-"}
              </p>
            </div>
            <div className="bg-gray-100 p-1 rounded-lg shadow-md">
              <p className="text-lg font-bold text-green-700">
                Retirement Date :
              </p>
              <p className="text-l font-semibold text-blue-800">
                {employee.retirementDate ? employee.retirementDate : "-"}
              </p>
            </div>
            <div className="bg-gray-100 p-1 rounded-lg shadow-md">
              <p className="text-lg font-bold text-green-700">
                Basis of Employment :
              </p>
              <p className="text-l font-semibold text-blue-800">
                {employee.basisOfEmployment ? employee.basisOfEmployment : "-"}
              </p>
            </div>
          </div>
        ) : (
          <p>Loading employee data...</p>
        )}
      </div>
      <EMPModal
        isModalOpen={isModalOpen}
        toggleModal={toggleModal}
        onEmployeeSelect={handleEmployeeSelect}
      />
    </div>
  );
};

export default EmployeeSelection;
